import React from 'react';
import {useTranslation} from 'react-i18next';
import {STATIC_IMAGE} from '../../../../config/config';
import {useTimetableDays} from '../../hooks/useTimetableDays';
import AddItemActions from '../addItemMenu/AddItemActions';
import * as css from './EmptyDay.css';

const emptyDayImage = `${STATIC_IMAGE}/app/timetable/pageNoLectures.png`;

interface EmptyDayProps {
    onAddLecture: () => void;
    onAddBreak?: () => void;
}

function EmptyDay({onAddLecture, onAddBreak}: EmptyDayProps) {
    const {t} = useTranslation('timetable');
    const {currentDateLabel} = useTimetableDays();

    return (
        <css.card>
            <css.content>
                <css.image src={emptyDayImage} alt="" />
                <css.title>{t('noLectures')}</css.title>
                <css.description>{t('noLecturesDescription', {day: currentDateLabel})}</css.description>
            </css.content>
            <css.actions>
                <AddItemActions onAddItem={onAddLecture} onAddBreak={onAddBreak} />
            </css.actions>
        </css.card>
    );
}

export default EmptyDay;
